import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { Footer } from './Footer';
import { useLabels } from '../providers/LabelsProvider';
import { useUser } from '../providers/UserProvider';
import { font, spacing, colors, media } from '../config';
import legoErrorPageSvg from 'url:../assets/lego-error-page.svg';
import { HomeBold } from '@lego/klik-icons-react';
import { isLoggedInWithWrongIdentityProvider } from '../utils/authUtils';
import { Auth } from 'aws-amplify';

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'red',
  background: `linear-gradient(${colors.boldColors.darkBlue.darkBlue80}, ${colors.boldColors.darkBlue.base})`,
  color: colors.neutralColors.white,
  textAlign: 'center',
  paddingBottom: 120,
});

const imageWrapperStyle = css({
  display: 'flex',
  alignItems: 'flex-end',
  marginTop: 40,
  width: 200,
  [media.medium]: {
    marginTop: 80,
    width: 'auto',
  },
});

const svgStyle = css({
  width: '100%',
  height: 'auto',
});

const svgWrapperLeftStyle = css({
  width: 120,
  marginRight: spacing.size5,
  '& > img': {
    transform: 'matrix(-1, 0, 0, 1, 0, 0);',
  },
});

const svgWrapperRightStyle = css({
  width: 220,
});

const headerStyle = css({
  fontWeight: font.weight.medium,
  marginBottom: spacing.size7,
  marginTop: spacing.size12,
  fontSize: font.size.size3,
  lineHeight: font.lineHeight.s,
  padding: `0 ${spacing.size4}px`,
  [media.medium]: {
    fontSize: font.size.size5,
  },
});

const bodyTextStyle = css({
  maxWidth: 500,
  lineHeight: font.lineHeight.m,
  padding: `0 ${spacing.size4}px`,
});

const contactMailLinkStyle = css({
  marginTop: spacing.size6,
  marginBottom: spacing.size12,
  '&:link, &:hover, &:active, &:visited': {
    color: colors.neutralColors.white,
    textDecoration: 'underline',
  },
});

const buttonStyle = css({
  marginTop: spacing.size6,
  padding: `${spacing.size2}px ${spacing.size4}px`,
  border: 'none',
  cursor: 'pointer',
  backgroundColor: colors.neutralColors.white,
  color: colors.boldColors.darkBlue.base,
  textDecoration: 'none',
  borderRadius: 4,
  fontWeight: font.weight.medium,
  '&:hover': {
    backgroundColor: colors.neutralColors.slate05,
  },
  display: 'flex',
  alignItems: 'center',
});

const ErrorPage = () => {
  const {
    labels: {
      svy_sign_in_button,
      svy_error_page_header,
      svy_error_page_body_text,
    },
  } = useLabels();
  const { legoContactEmail, cognitoData } = useUser();
  const isLegacyUser = isLoggedInWithWrongIdentityProvider(cognitoData);

  return (
    <div>
      <div css={containerStyle}>
        <div css={imageWrapperStyle}>
          <div css={svgWrapperLeftStyle}>
            <img src={legoErrorPageSvg} css={svgStyle} />
          </div>
          <div css={svgWrapperRightStyle}>
            <img src={legoErrorPageSvg} css={svgStyle} />
          </div>
        </div>
        {isLegacyUser ? (
          <button
            css={buttonStyle}
            data-transaction-name="Sign in"
            aria-label="Sign in"
            onClick={() =>
              Auth.federatedSignIn({
                customProvider: process.env.FEDERATED_AUTH_PROVIDER,
              })
            }
          >
            <HomeBold size={24} color={colors.boldColors.darkBlue.base} />
            <span
              css={css`
                margin-left: ${spacing.size2}px;
              `}
            >
              {svy_sign_in_button}
            </span>
          </button>
        ) : (
          <Link to="/" css={buttonStyle}>
            <HomeBold size={24} color={colors.boldColors.darkBlue.base} />
            <span
              css={css`
                margin-left: ${spacing.size2}px;
              `}
            >
              Home
            </span>
          </Link>
        )}
        <h1 css={headerStyle}>{svy_error_page_header}</h1>
        <p css={bodyTextStyle}>{svy_error_page_body_text}</p>
        <a css={contactMailLinkStyle} href={`mailto:${legoContactEmail}`}>
          {legoContactEmail}
        </a>
      </div>
      <Footer />
    </div>
  );
};

export { ErrorPage };
